
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {
  components: {
    'component-permanent-transfers': () => import(/* webpackChunkName: "transfers" */ './PermanentTransfersList.vue'),
    ComponentFilters: () => import(/* webpackChunkName: "components" */ '../../components/Filter.vue'),
    'component-placeholder': () => import(/* webpackChunkName: "components" */ '../../components/Placeholder.vue')
  },

  data: () => ({
    filters: {},
    loading: false,
    activeTab: 'all'
  }),

  computed: {
    ...mapGetters([
      'transfers',
      'delayedTransfers',
      'periodicTransfers'
    ]),

    hasResult () {
      return !this.loading && this.transfersList.length
    },

    isAll () {
      return this.activeTab === 'all'
    },

    isDelayed () {
      return this.activeTab === 'delayed'
    },

    isPeriodic () {
      return this.activeTab === 'periodic'
    },

    transfersList () {
      if (this.isAll) {
        return this.transfers
      } else if (this.isDelayed) {
        return this.delayedTransfers
      } else {
        return this.periodicTransfers
      }
    },

    hasDocuments () {
      return this.transfersList.some(transfer => transfer.operation && transfer.operation.documents.length)
    }
  },

  watch: {
    'store.data.user.account.uuid': function () {
      this.loading = true
      this.getTransfers().then(() => {
        this.loading = false
      })
    }
  },

  mounted () {
    if (store.transfersTab && !['direct', 'import', 'service'].includes(store.transfersTab)) {
      this.toggleTab(store.transfersTab)
      delete store.transfersTab
      window.localStorage.setItem(store.localStorageKey, JSON.stringify(store.data))
    } else {
      this.getTransfersList()
    }

    this.$bus.$on('delete-success', this.refreshTransfersList)
    this.$bus.$on('refresh-transfers-list', this.refreshTransfersList)
    this.$bus.$on('filters', this.onFilter)
  },

  destroyed () {
    this.$bus.$off('delete-success', this.refreshTransfersList)
    this.$bus.$off('refresh-transfers-list', this.refreshTransfersList)
    this.$bus.$off('filters', this.onFilter)
  },

  methods: {
    ...mapActions([
      'getTransfers'
    ]),

    showDetails (transfer) {
      this.showSidePanel({
        childVue: 'transfer-detail',
        dataModel: transfer,
        wrapperClass: 'sidepanel--md',
      })
    },

    onFilter (filters) {
      if (this.filters.type) {
        filters.type = this.filters.type
      }
      this.filters = filters
      this.getTransfers(this.filters)
    },

    getTransfersList (type = null, activateLoading = true) {
      this.loading = activateLoading
      if (type) {
        this.filters.type = type
      } else {
        delete this.filters.type
      }
      this.getTransfers(this.filters).then(() => {
        this.loading = false
      })
    },

    deleteTransfer (transferId) {
      this.showModal({
        childVue: 'delete',
        dataModel: {
          url: `${store.api.base}/transfers/${transferId}`,
          title: this.$i18n.t('modal.delete.transfer.title'),
          content: this.$i18n.t('modal.delete.transfer.content')
        }
      })
    },

    toggleTab (type) {
      if (type === 'all' && !this.isAll) {
        this.getTransfersList()
      } else if (type === 'delayed' && !this.isDelayed) {
        this.getTransfersList(type)
      } else if (type === 'periodic' && !this.isPeriodic) {
        this.getTransfersList(type)
      }
      this.activeTab = type
    },

    refreshTransfersList () {
      if (this.isDelayed) {
        this.getTransfersList('delayed', false)
      } else if (this.isPeriodic) {
        this.getTransfersList('periodic', false)
      } else {
        this.getTransfersList(null, false)
      }
    }
  }
}
